<template>
  <ngc-input-dropdown
    v-value="selectedGuids"
    multiselect
    wrap-chips
    placeholder="Select org IDs this user can access"
    :disabled="disabled"
    :options.prop="orgOptions"
    @change="onChange"
  />
</template>

<script>
export default {
  name: 'SrOrganizationCombobox',
  directives: {
    // Mirror the platform's `v-value` directive: set the element's value
    // property on insert and on every update so the Gator dropdown reliably
    // reflects the selected chips.
    value: {
      inserted (el, binding) {
        el.value = binding.value
      },
      update (el, binding) {
        el.value = binding.value
      }
    }
  },
  props: {
    organizations: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    }
  },
  computed: {
    selectedOrgs () {
      return Array.isArray(this.value) ? this.value : []
    },
    selectedGuids () {
      return this.selectedOrgs.map(o => o.guid)
    },
    orgOptions () {
      return this.organizations.map(org => ({ label: this.displayName(org), value: org.guid }))
    }
  },
  methods: {
    onChange (event) {
      const guids = event.detail.value || []
      const orgs = guids
        .map(guid => this.organizations.find(o => o.guid === guid))
        .filter(Boolean)
      this.$emit('input', orgs)
    },
    displayName (org) {
      if (org.active) {
        return org.name
      }
      return `${org.name} - inactive`
    }
  }
}
</script>

<style scoped>
</style>
